import { gql } from '@apollo/client';

import { PageInfoFragmentDoc } from '../../../graphql/fragments/PageInfo.generated';
import type * as GraphQLTypes from '../../../graphql/types.generated';
export type GetAccountBusinessUnitsQueryVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
  includeArchived?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Boolean']['input']>;
  after?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  before?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  first?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  last?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  order?: GraphQLTypes.InputMaybe<GraphQLTypes.SortInput>;
}>;

export type GetAccountBusinessUnitsQueryResult = { __typename?: 'Query' } & {
  accountBusinessUnits?: GraphQLTypes.Maybe<
    { __typename?: 'AccountConnection' } & Pick<GraphQLTypes.AccountConnection, 'totalCount'> & {
        nodes: Array<
          GraphQLTypes.Maybe<
            { __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'referencePrefix' | 'tradingName' | 'type'>
          >
        >;
        pageInfo: { __typename: 'PageInfo' } & Pick<
          GraphQLTypes.PageInfo,
          'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'
        >;
      }
  >;
};

export const GetAccountBusinessUnitsDocument = gql`
  query getAccountBusinessUnits(
    $accountId: String!
    $includeArchived: Boolean
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: SortInput
  ) {
    accountBusinessUnits(
      accountId: $accountId
      includeArchived: $includeArchived
      after: $after
      before: $before
      first: $first
      last: $last
      order: $order
    ) {
      nodes {
        id
        referencePrefix
        tradingName
        type
      }
      pageInfo {
        ...PageInfo
      }
      totalCount
    }
  }
  ${PageInfoFragmentDoc}
`;
